"use client";

import { c as _c } from "react/compiler-runtime";
export default function CarouselHeader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="tw-mb-8 md:tw-mb-10 tw-px-4 md:tw-px-6 md:tw-text-center lg:tw-px-8"><span className="tw-m-0 tw-text-xl tw-font-semibold tw-tracking-tight tw-text-white sm:tw-text-2xl md:tw-text-3xl">Community favorites from artists in the network</span></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}